var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#DADFE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 33.7497C45.3766 33.7497 43.25 35.8763 43.25 38.4997V46.4163C43.25 49.0397 45.3766 51.1663 48 51.1663C50.6234 51.1663 52.75 49.0397 52.75 46.4163V38.4997C52.75 35.8763 50.6234 33.7497 48 33.7497ZM49.5833 60.5794V63.0413C49.5833 63.9158 48.8745 64.6247 48 64.6247C47.1255 64.6247 46.4167 63.9158 46.4167 63.0413V60.5794C39.2917 59.7917 33.75 53.7512 33.75 46.4163C33.75 45.5419 34.4589 44.833 35.3333 44.833C36.2078 44.833 36.9167 45.5419 36.9167 46.4163C36.9167 52.5375 41.8788 57.4997 48 57.4997C54.1212 57.4997 59.0833 52.5375 59.0833 46.4163C59.0833 45.5419 59.7922 44.833 60.6667 44.833C61.5411 44.833 62.25 45.5419 62.25 46.4163C62.25 53.7512 56.7083 59.7917 49.5833 60.5794ZM48 30.583C52.3723 30.583 55.9167 34.1274 55.9167 38.4997V46.4163C55.9167 50.7886 52.3723 54.333 48 54.333C43.6277 54.333 40.0833 50.7886 40.0833 46.4163V38.4997C40.0833 34.1274 43.6277 30.583 48 30.583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayMic);
export default __webpack_public_path__ + "static/media/grayMic.9d0092d720957fd4362da09b5fd9e162.svg";
export { ForwardRef as ReactComponent };